module.exports = __webpack_public_path__ + "img/FB1211 metro logo cmyk.4dcbbdc2.jpg";